import React from "react";

import { css } from "@emotion/react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { fontColor, FONTS } from "../../../styles/fonts";
import { richTextStyles } from "../../../styles/rich-text";
import { CSS_MQ } from "../../../styles/breakpoints";
import { responsivePlainTextStyles } from "../../../styles/text-styles";
import { OverlappingImagesTextElementType } from "@swo/storefront";
import { SORichTextRenderer } from "../../_shared-components/so-rich-text";

export const OverlappingImagesTextElement: ReactTFC<OverlappingImagesTextElementType> = props => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;

        background-color: ${CSS_COLORS.GreenWhite};

        padding: 18px;

        ${CSS_MQ.atLeastMd} {
          padding: 40px;
        }

        ${CSS_MQ.atLeastLg} {
          padding: 50px;
        }
      `}
    >
      <span
        css={[
          FONTS.MinervaModern500,
          css`
            display: block;

            font-size: 30px;

            margin-top: 0;
            margin-bottom: 20px;

            color: ${CSS_COLORS.Green};
            letter-spacing: 1.5px;
            line-height: 32px;

            text-transform: uppercase;
          `,
        ]}
      >
        {props.headline}
      </span>
      <div
        css={[
          FONTS.SwarovskiFutura300,
          fontColor.black,
          css`
            p {
              margin-bottom: 0;
            }

            > *:first-child {
              margin-top: 0;
            }
          `,
          responsivePlainTextStyles,
          richTextStyles,
        ]}
      >
        <SORichTextRenderer richText={props.text} options={"with-hyperlinks"} />
      </div>
    </div>
  );
};
